<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="搜索词:" class="query-form-item">
                <el-input v-model="query.search_word" placeholder="搜索词" clearable style="width: 150px;"></el-input>
            </el-form-item>
<!--            <el-form-item label="已点击的ASIN:" class="query-form-item">-->
<!--                <el-input v-model="query.asin	" placeholder="已点击的ASIN" clearable style="width: 150px;"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="国家：" class="query-form-item">
                <el-select
                    v-model="query.amazon_site"
                    ref="carrerSelect"
                    style="width: 100px;"
                    size="mini"
                    filterable
                    @change="change"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.value"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()" style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content "
            border
            @sort-change="handleSortChange"
            style="width: 100%;">
            <el-table-column
                label="市场"
                width="110"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.amazon_site }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="搜索词"
                min-width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.search_word }}</div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                min-width="120"
                label="ara排名趋势">
                <template slot-scope="scope">
                    <div v-loading="loadingkeyword_aratracker"  :id="'keyword_aratracker' + scope.row.search_word" @click="oncharts_arakeyword(scope.row)" class="chart spinner_div"></div>
                </template>
            </el-table-column>
            <el-table-column
                label="搜索词排名"
                width="110"
                prop="search_rank"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.search_rank }}</div>
                </template>
            </el-table-column>

            <el-table-column label="点击量最高的品牌 #1" width="150" prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_brand_1 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的类别 #1" width="150"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_category_1 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #1：ASIN" width="180"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_asin_1 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #1：商品名称" width="200"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.product_title_1 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #1：点击份额" width="220"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ parseFloat((scope.row.click_share_1 || 0) * 100).toFixed(2) }}%</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #1：转化份额" width="200"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ parseFloat((scope.row.conversion_share_1 || 0) * 100).toFixed(2) }}%</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的品牌 #2" width="180"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_brand_2 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的类别 #2" width="200"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_category_2 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #2：ASIN" width="200"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_asin_2 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #2：商品名称" width="200"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.product_title_2 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #2：点击份额" width="220"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ parseFloat((scope.row.click_share_2 || 0) * 100).toFixed(2) }}%</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #2：转化份额" width="200"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ parseFloat((scope.row.conversion_share_2 || 0) * 100).toFixed(2) }}%</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的品牌 #3" width="150"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_brand_3 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的类别 #3" width="150"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_category_3 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #3：ASIN" width="180"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.click_asin_3 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #3：商品名称" width="200"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.product_title_3 }}</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #3：点击份额" width="210"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ parseFloat((scope.row.click_share_3 || 0) * 100).toFixed(2) }}%</div></template>
            </el-table-column>
            <el-table-column label="点击量最高的商品 #3：转化份额" width="210"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ parseFloat((scope.row.conversion_share_3 || 0) * 100).toFixed(2) }}%</div></template>
            </el-table-column>
            <el-table-column label="年份" width="110"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.year }}</div></template>
            </el-table-column>
            <el-table-column label="月份" width="110"  prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.month }}</div></template>
            </el-table-column>
            <el-table-column label="报告日期" width="110" prop="search_rank" align="center">
                <template slot-scope="scope"><div>{{ scope.row.report_date }}</div></template>
            </el-table-column>

        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next">
        </el-pagination>
        <charts ref="charts" :visible="ctrl.chartsVisible" :title="ctrl.dialogTitle" :charts_keyword="charts_keyword" :charts_id="charts_keyword" @close-callback="closeCllback"></charts>
    </div>
</template>

<script>
import * as api from "@/api/ara/ara";
import * as aapi from '@/api/Product/Product.js'
import * as apis from "@/api/etyma/etyma";
import * as Highcharts from "highcharts";
import Charts from "../etyma/charts";
export default {
    components: { Charts },
    data() {
        return {
            ctrl: {
                chartsVisible: false
            },
            tableHeight: null,
            us_arr: [
                {
                    value: "Amazon.com",
                    us: "us",
                    title: "美国"
                },
                {
                    value: "Amazon.co.uk",
                    us: "uk",
                    title: "英国"
                },
                {
                    value: "Amazon.de",
                    us: "de",
                    title: "德国"
                }
            ],
            charts_keyword: "",
            query: {
                page: 1,
                limit: 20,
                total: 0,
                amazon_site: "Amazon.com",
                search_word: ''
            },
            list: [],
            loadingkeyword_aratracker: false,
            requestCount: 0,
            loading: false
        };
    },
    created() {
        this.getList();
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    methods: {
        getList() {
            let count = this.requestCount;
            count = count + 1;
            this.requestCount = count;
            this.loading = true;
            let that = this;
            aapi.ara_index_list(this.query)
                .then(res => {
                    this.loading = false;
                    if (this.requestCount != count) {
                        this.loadingkeyword_aratracker = false;
                        return;
                    }
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.query.total = res.data.total;
                        let list = JSON.parse(JSON.stringify(that.list));
                        let arr_key_obj = {};
                        arr_key_obj.country_code = that.iscountry();
                        arr_key_obj.keywords = [];
                        for (let i = 0; i < list.length; i++) {
                            arr_key_obj.keywords.push(list[i].search_word);
                        }
                        if (arr_key_obj.keywords.length != 0) {
                            this.aratrend_batch(
                                arr_key_obj.keywords,
                                arr_key_obj.country_code,
                                count
                            );
                        } else {
                            this.loadingkeyword_aratracker = false;
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        iscountry() {
            let arrcountry = [...this.us_arr];
            for (let i = 0, l = arrcountry.length; i < l; i++) {
                if (arrcountry[i].value == this.query.amazon_site) {
                    return arrcountry[i].value;
                }
            }
        },
        toPercent(num) {
            return (Math.round(num * 10000) / 100).toFixed(2) + "%";
        },
        //获取关键词曲线图数据
        async aratrend_batch(arr, country_code, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingkeyword_aratracker = false);
            }
            await aapi.ara_index_trend_batch({
                search_word_list: arr,
                amazon_site: country_code
                })
                .then(res => {
                    that.loadingkeyword_aratracker = false;
                    console.log('------')
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].ara_date = [];
                            for (let j = 0; j < data[list[i].search_word].year.length; j++) {
                                let str = data[list[i].search_word].year[j] + "-" + data[list[i].search_word].month[j];
                                list[i].ara_date.push(str);
                            }
                            list[i].search_rank_list = data[list[i].search_word].search_rank;
                        }
                        that.list = list;
                        for (let i = 0; i < that.list.length; i++) {
                            console.log(this.list)
                            if (that.list[i].search_rank_list) {
                                that.workload_aratracker("keyword_aratracker" + that.list[i].search_word, that.list[i]);
                            }
                        }
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    that.loadingkeyword_aratracker = false;
                });
        },
        workload_aratracker(id_name, data) {
            let workload_id = document.getElementById(id_name);
            let datas = [];
            for (let i = 0; i < data.search_rank_list.length; i++) {
                datas.push(
                    data.search_rank_list[i] == null || data.search_rank_list[i] == 0 ? null : data.search_rank_list[i]
                );
            }
            this.sparkLine(workload_id, datas, data.ara_date, 1);
        },
        sparkLine(div, datas, dates, index) {
            var options = {
                chart: {
                    borderWidth: 0,
                    backgroundColor: "#fff",
                    // type: "area",
                    margin: [8, 40, 8, 10],
                    width: 100,
                    height: 36,
                    style: {
                        overflow: "visible"
                    },
                    skipClone: true
                },
                title: {
                    text: null
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    categories: dates,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: [],
                    tickWidth: 0,
                    lineColor: "#fff"
                },
                yAxis: {
                    reversed: true,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    minPadding: 0,
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                legend: {
                    enabled: false
                },
                exporting: { enabled: false },
                tooltip: {
                    formatter: function() {
                        if (index == 1) {
                            return `<span style="font-size: 10px;">${
                                this.x
                            }</span><br/><b>${this.y}</b>`;
                        }
                        if (index == 2) {
                            return `<span style="font-size: 10px;">${
                                this.x
                            }</span><br/><b>${this.y * -1}</b>`;
                        }
                    },
                    hideDelay: 0,
                    outside: true
                },
                series: [{ data: datas }],
                plotOptions: {
                    series: {
                        animation: false,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            radius: 1,
                            states: {
                                hover: {
                                    radius: 2
                                }
                            }
                        },
                        fillOpacity: 0.25
                    },
                    column: {
                        negativeColor: "#910000",
                        borderColor: "silver"
                    }
                }
            };
            return new Highcharts.Chart(div, options);
        },
        handleSortChange(val) {
            if (val.order == "ascending") {
                this.query.desc = "desc";
                this.query.order = val.prop;
            } else if (val.order == "descending") {
                this.query.desc = "asc";
                this.query.order = val.prop;
            }
            this.getList();
        },
        //重置
        onReset() {
            this.query.amazon_site = "Amazon.com";
            this.query.search_word = "";
            this.query.page = 1
            this.getList();
        },
        //打开关键词曲线图ara
        oncharts_arakeyword(data) {
            let that = this;
            this.charts_keyword = data.search_word;
            this.ctrl.dialogTitle = `${data.search_word} 的ara排名趋势图`;
            this.ctrl.chartsVisible = true;
            setTimeout(function() {
                that.$refs.charts.getList(data.search_word, that.iscountry());
            }, 100);
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList();
        },
        change() {
            this.query.page = 1
            this.getList();
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.chartsVisible = false;
            if (isshow) return;
            this.getList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.table_content /deep/ .el-table__body tr:hover > td {
    background-color: rgba(0, 0, 0, 0) !important;
}
</style>
